import React from 'react';

class QRLoader extends React.Component {
	render() {
		return (
			<div className="fullscreen-loader">
				<div className="button" onClick={ () => this.props.parent.cancelQRLoading() }>Avbryt</div>

				<div className="fullscreen-loader-middle">
					<svg className="circle-chart" viewBox="0 0 33.83098862 33.83098862" width="100" height="100" xmlns="http://www.w3.org/2000/svg">
						<defs>
							<linearGradient id="gradient" x1="0%" y1="0%" x2="0%" y2="100%">
								<stop offset="0%" stopColor="#F74067" />
								<stop offset="100%" stopColor="#FA7942" />
							</linearGradient>
						</defs>

						<circle className="circle-chart__background" stroke="#49203F" strokeWidth="2" fill="none" cx="16.91549431" cy="16.91549431" r="15.91549431"/>
						<circle className="circle-chart__circle" stroke="url(#gradient)" strokeWidth="2" strokeDasharray="90,100" strokeLinecap="round" fill="none" cx="16.91549431" cy="16.91549431" r="15.91549431"/>
					</svg>

					<div>
						Hämtar QR-kod...
					</div>
				</div>
			</div>
		)
	}
}
export default QRLoader;



// WEBPACK FOOTER //
// ./src/components/user/Dashboard/QRLoader.js